import { RealTimeLobbyGameDetails } from './RealTimeLobbyGameDetails';
import { RealTimeLobbyGameModel } from './RealTimeLobbyGameModel';
import { Common } from 'src/domains/common/Common';
import { EnvironmentState } from 'src/domains/layouts/state/environmentState/EnvironmentState';

export class RealTimeLobbySocket {
    private readonly data: RealTimeLobbyGameDetails | null = null;

    public constructor(private readonly common: Common) {
        const { envVariables, isBrowser } = EnvironmentState.get(this.common);
        if (envVariables.casinoRtlUrl === null) {
            console.warn('Casino RTL host is not defined.');
            return;
        }
        this.data = new RealTimeLobbyGameDetails(envVariables.casinoRtlUrl, envVariables.universe, isBrowser);
    }

    public getModel(gameId: number): RealTimeLobbyGameModel | null {
        if (this.data === null) {
            return null;
        }
        return this.data.getModel(gameId);
    }
}
